document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('variant:change', (evt) => {
    const variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    // Redirect to canonical URL with variant query so the whole page reloads
    const url = `${window.location.pathname}?variant=${variant.id}`;
    if (window.location.href !== url) {
      window.location.href = url;
    }
  });
});
